import * as React from 'react';

/**
 * Cell with list values.
 * @param {Object} params
 * @returns {JSX.Element}
 */
export default function (params) {
  const {value, column, row, fields} = params;

  return (
    <div className='cell cell--list'>
      {value && value.length > 0 && value.map((item, idx) => {
        return (
          <span key={idx}>{item}</span>
        );
      })}
    </div>
  );
}
